/**
 * 导航栏中部：航拍建模 + 地图图层切片短进度（不占地图空间）
 */
import React, { useEffect, useState } from 'react';
import { subscribeOrthoStatus } from '../utils/orthoStatusBus';
import apiFetch from '../utils/apiFetch';
import { shouldShowPage } from '../utils/permissionControl';

function pickLabel(data) {
  if (!data?.active) return '';
  return String(data.primary?.label || data.text || '').trim();
}

async function fetchSummary(path) {
  try {
    const res = await apiFetch(path);
    const data = await res.json().catch(() => ({}));
    if (!data?.success) return '';
    return pickLabel(data);
  } catch (_) {
    return '';
  }
}

export default function OrthoNavStatus() {
  const [orthoText, setOrthoText] = useState('');
  const [sliceText, setSliceText] = useState('');

  const canOrtho =
    shouldShowPage('航拍建模')
    || shouldShowPage('航拍建模审批')
    || shouldShowPage('航拍图层查看');
  const canSlice =
    shouldShowPage('地图图层管理')
    || shouldShowPage('地图图层查看')
    || shouldShowPage('成品管理');
  const canSee = canOrtho || canSlice;

  useEffect(() => {
    if (!canSee) return undefined;

    let alive = true;

    const unsub = canOrtho
      ? subscribeOrthoStatus((payload) => {
          if (!payload?.active) {
            setOrthoText('');
            return;
          }
          setOrthoText(String(payload.primary?.label || payload.text || '').trim());
        })
      : () => {};

    const pull = async () => {
      const jobs = [];
      if (canOrtho) {
        jobs.push(
          fetchSummary('/api/ortho/status-summary').then((t) => {
            if (alive) setOrthoText(t);
          })
        );
      }
      if (canSlice) {
        jobs.push(
          fetchSummary('/api/map-layers/status-summary').then((t) => {
            if (alive) setSliceText(t);
          })
        );
      }
      await Promise.all(jobs);
    };

    pull();
    const t = setInterval(pull, 8000);
    return () => {
      alive = false;
      unsub();
      clearInterval(t);
    };
  }, [canSee, canOrtho, canSlice]);

  const parts = [];
  if (orthoText) parts.push(orthoText);
  if (sliceText) parts.push(sliceText);
  const text = parts.join(' · ');

  if (!canSee || !text) return null;

  return (
    <div className="nav-ortho-status" title={text}>
      <div className="nav-ortho-status-inner">
        <span className="nav-ortho-status-dot" />
        <span className="nav-ortho-status-text">{text}</span>
      </div>
    </div>
  );
}
